var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"container"}),_c('Graphic'),_c('Three'),_c('Popular'),_c('Commission'),_c('Hit'),_c('Media'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }